export default __webpack_public_path__ + "static/media/person-min.78a4d775.png";